import { buildEntityKeys } from '@soniq/public-manager'

export const messageKeys = buildEntityKeys<{
  contactId: string | null
}>('message')
